import { ConfigProvider, FormListOperation, } from "antd";
import en_US from "antd/lib/locale/en_US";
import { enUSIntl, ProConfigProvider } from "@ant-design/pro-provider";
import {
  ActionType,
  FormListActionType,
  PageContainer,
  ProFormInstance,
  StepsForm,
} from "@ant-design/pro-components";
import SearchForm from "./SearchForm";
import { createContext } from "react";
import { useRef, useState } from "react";
import AddFormPageOne from "./AddFormPageOne";
import AddFormSecondPage from './AddFromPageTwo';
import AddFormThirdPage from "./AddFormPageThree";
import axios from "axios";
import AddEntryStepForm from "./AddEntryForm";

type PageContext = {
  stepFormRef?: React.MutableRefObject<ProFormInstance>;
  firstFormPageRef?: React.MutableRefObject<ProFormInstance>;
  secondFormPageRef?: React.MutableRefObject<ProFormInstance>;
  listRef?: React.MutableRefObject<FormListActionType>;
  releasesActionRef?: React.MutableRefObject<ActionType>;
  artists?: SelectedArtistsByCategory;
  setArtists?: React.Dispatch<React.SetStateAction<SelectedArtistsByCategory>>;
  trackAction?: ProFormListRowAction;
  setTrackAction?: React.Dispatch<React.SetStateAction<ProFormListRowAction>>;
};

type ProFormListRowAction = FormListOperation & {
  getCurrentRowData: () => any;
  setCurrentRowData: (data: any) => void;
};

type SelectedArtistsByCategory = {
  main_artists?: string[];
  featuring_artists?: string[];
  composers?: string[];
  authors?: string[];
  remixers?: string[];
  producers?: string[];
  arrangers?: string[];
  publishers?: string[];
};

export const DigitalAssetPageContext = createContext<PageContext>({});

export const PageContextProvider = ({ children }: any) => {
  const stepFormRef = useRef<ProFormInstance>();
  const firstFormPageRef = useRef<ProFormInstance>();
  const secondFormPageRef = useRef<ProFormInstance>();
  const listRef = useRef<FormListActionType>();
  const [artists, setArtists] = useState<SelectedArtistsByCategory>({});
  const [trackAction, setTrackAction] = useState<ProFormListRowAction>();
  const releasesActionRef = useRef<ActionType>();

  return (
    <DigitalAssetPageContext.Provider
      value={{
        stepFormRef,
        firstFormPageRef,
        secondFormPageRef,
        listRef,
        releasesActionRef,
        artists,
        setArtists,
        trackAction,
        setTrackAction,
      }}
    >
      {children}
    </DigitalAssetPageContext.Provider>
  );
};

function AddAsset() {
  const stepFormRef = useRef<ProFormInstance>();
  const firstFormPageRef = useRef<ProFormInstance>();
  const secondFormPageRef = useRef<ProFormInstance>();

  //alagi

  return (
    <PageContextProvider>
    <PageContainer>
            <AddEntryStepForm formData={stepFormRef} /> 
    </PageContainer>
    </PageContextProvider>
  );
}
export default AddAsset;
